import { fetchMarketingContactsOnMCRenewal, fetchMarketingContactsOnSwitchToMC } from 'pricing-pages-lib/api/CrmSearchApi';
import { createRequestTypes, createRequestActions } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
import { MARKETING_CONTACTS } from './constants/RequestedDataTypes';
import { isDevPortalSelector } from '../selectors/ScopeSelectors';
export const FetchMarketingContactsRequestTypes = createRequestTypes(MARKETING_CONTACTS);
export const FetchMarketingContactsActions = createRequestActions(FetchMarketingContactsRequestTypes);
export const fetchMarketingContacts = () => (dispatch, getState) => {
  const state = getState();
  const isDevPortal = isDevPortalSelector(state);
  return makeFetchRequest({
    requestActions: FetchMarketingContactsActions,
    fetch: (...args) => {
      const promises = [fetchMarketingContactsOnMCRenewal, fetchMarketingContactsOnSwitchToMC];
      return Promise.all(promises.map(promise => promise(...args)));
    },
    payload: isDevPortal
  })(dispatch, getState, undefined);
};